import {GameModeTransitionController} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionController";
import {WinterHoardGameModuleConfig} from "../../WinterHoardGameModuleConfig";


export class PickTransitionController extends GameModeTransitionController {

    constructor(fromMode:string, toMode:string) {
        super(fromMode, toMode);
    }

    /**
     * Set up mode views and layout while screen is covered by intro/outro screen.
     */
    protected prepareToEnterMode():void {
        //debugger;
        if(this._toMode === "FREESPIN_TRANSFORM" || this._toMode === "FREESPIN_MULTIPLIER") {
            //console.log("MODE: " + this._toMode);
            if(this._toMode === "FREESPIN_TRANSFORM") {
                WinterHoardGameModuleConfig.freeSpinCounterView.show();
            }
            else if(this._toMode === "FREESPIN_MULTIPLIER") {
                WinterHoardGameModuleConfig.freeSpinMultiplierView.show();
            }
            //if(this._serverData instanceof ParsedGameData) {
                //WinterHoardGameModuleConfig.freeSpinCounterView.updateAll();
            //}
        }

        super.prepareToEnterMode();
    }


}